import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaUsers, FaCog } from 'react-icons/fa';
import { MdConfirmationNumber, MdSell } from 'react-icons/md';
import { GiCoinflip } from 'react-icons/gi';
import { useTranslation } from 'react-i18next';
import { Store } from '../../Store';
import './AdminNavbarOptions.css';

function AdminNavbarOptions({ companyName, Collapse }) {
  const { t } = useTranslation();
  const { state } = useContext(Store);
  const { userInfo } = state;

  return (
    <div className='admin-navbar-options'>
      <div className='admin-navbar-brand'>
        <Link to='/' onClick={Collapse}>
          <img src='/logoFooter.svg' alt={companyName} />
        </Link>
      </div>
      <ul className='mobile-menu-Admin'>
        {/* <li>
          <Link className='nav-link' to='/AdminScreen/stats' onClick={Collapse}>
            <FaChartBar />
            <h3>{t('admin.stats')}</h3>
          </Link>
        </li> */}

        <li>
          <Link className='nav-link' to='/AdminScreen/tickets' onClick={Collapse}>
            <MdConfirmationNumber />
            <h3>{t('admin.numbers')}</h3>
          </Link>
        </li>

        <li>
          <Link className='nav-link' to='/AdminScreen/reservas' onClick={Collapse}>
            <MdSell />
            <h3>{t('admin.reservations')}</h3>
          </Link>
        </li>

        {(userInfo?.isAdmin || userInfo?.isSuperAdmin) && (
          <li>
            <Link className='nav-link' to='/AdminScreen/rifas' onClick={Collapse}>
              <GiCoinflip />
              <h3>{t('admin.raffles')}</h3>
            </Link>
          </li>
        )}

        {(userInfo?.isAdmin || userInfo?.isSuperAdmin) && (
          <li>
            <Link className='nav-link' to='/AdminScreen/Config' onClick={Collapse}>
              <FaCog />
              <h3>{t('admin.setup')}</h3>
            </Link>
          </li>
        )}

        {userInfo && userInfo.isSuperAdmin && (
          <li>
            <Link className='nav-link' to='/AdminScreen/users' onClick={Collapse}>
              <FaUsers />
              <h3>{t('admin.administrators')}</h3>
            </Link>
          </li>
        )}

        <li>
          <Link className='nav-link' to='/' onClick={Collapse}>
            <FaHome />
            <h3>{t('admin.home')}</h3>
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default AdminNavbarOptions;
